import styles from "../css/invoice.module.css";

export default function FinalizeConfirmationModal({ 
  show, 
  onCancel, 
  onConfirm, 
  disabled = false 
}) {
  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.modalTitle}>Finalize invoice?</h3>
        <p className={styles.modalText}>
          This will save the consultation and end the session.
        </p>
        <div className={styles.modalActions}>
          <button className={styles.modalCancelBtn} onClick={onCancel}>
            Cancel
          </button>
          <button 
            className={styles.modalConfirmBtn} 
            onClick={onConfirm} 
            disabled={disabled}
          >
            Finalize
          </button>
        </div>
      </div>
    </div>
  );
}
